<div class="assign-modal__backdrop animated fadeIn">
	<div class="assign-modal__wrapper">
		<div class="assign-modal">
			<div class="assign-modal__header">
				<h3 class="assign-modal__title">{{ data?.options['title'] }}</h3>
			</div>
			<div class="assign-modal__content">
				<p>{{ data?.options['description'] }}</p>
				<div class="assign-modal__info">
					<p>
						<b>{{ usageMode | titlecase }} Name:</b> {{ getName() }}
					</p>
					<div class="assign-modal__form-field-wrapper">
						<b>Organizations:</b>
						<ng-select
							[items]="orgsList"
							[multiple]="true"
							[closeOnSelect]="false"
							[hideSelected]="true"
							bindLabel="org_name"
							bindValue="org_id"
							placeholder="Select Organizations"
							[(ngModel)]="selectedOrgs"
							name="selectedOrgs"
							ngDefaultControl
							[searchFn]="customSearchFn"
						>
							<ng-template ng-option-tmp let-item="item">
								<small>{{ item.org_name }} ({{ item.org_id }})</small>
							</ng-template>
						</ng-select>
					</div>
					<div class="assign-modal__form-field-wrapper" *ngIf="usageMode === 'user'">
						<b>Whitelabel:</b>
						<ng-select
							[items]="whitelabels"
							placeholder="Select Whitelabel"
							[(ngModel)]="selectedWl"
							name="whiteLabels"
							requried
							ngDefaultControl
						>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="assign-modal__actions">
				<button class="assign-modal__close" (click)="closeEvent()">Close</button>
				<button class="assign-modal__create" [disabled]="isApplyDisabled" (click)="confirm()">Apply</button>
			</div>
			<ng-container *ngIf="showConfirm">
				<app-show-confirm (confirmed)="onConfirmed($event)"></app-show-confirm>
			</ng-container>
			<ng-container *ngIf="initProcess">
				<app-show-process [process]="processStatus | async"></app-show-process>
			</ng-container>
		</div>
	</div>
</div>
